import { readAsArrayBuffer } from '../common/readers';
import request from '../common/request';
import { AbortError } from '../common/errors';
import { decryptProjectData } from '../common/gandi/decode-sb3-file.js';
import { downloadProject as _downloadProject } from './download-project.js';

const downloadProject = async (buffer, progressCallback, options = {}) => {
  const controller = typeof AbortController === 'function' && new AbortController();
  let reject;
  return {
    promise: new Promise((_resolve, _reject) => {
      reject = _reject;

      _downloadProject(buffer, progressCallback, controller && controller.signal, options)
        .then(result => _resolve(result))
        .catch(err => _reject(err));
    }),

    terminate: () => {
      reject(new AbortError());
      if (controller) {
        controller.abort();
      }
    }
  };
};

const fromURL = async (url, progressCallback) => {
  const buffer = await request({
    url,
    type: 'arraybuffer',
    progressCallback: (progress) => {
      progressCallback('fetch', progress);
    }
  });
  return downloadProject(buffer, progressCallback);
};

const fromCCWSb3URL = async (url, progressCallback) => {
  const buffer = await request({
    url,
    type: 'arraybuffer',
    progressCallback: (progress) => {
      progressCallback('fetch', progress);
    }
  });

  const decryptedBuffer = decryptProjectData(buffer, url);
  return downloadProject(decryptedBuffer, progressCallback, {
    assetHost: 'https://m.ccw.site/user_projects_assets/$id'
  });
};

const fromID = (id, token, progressCallback) => {
  const tokenPart = token ? `?token=${token}` : '';
  const url = `https://projects.scratch.mit.edu/${id}${tokenPart}`;
  return fromURL(url, progressCallback);
};

const fromFile = async (file, progressCallback) => {
  const buffer = await readAsArrayBuffer(file);
  return downloadProject(buffer, progressCallback);
};

export default {
  fromID,
  fromURL,
  fromFile,
  fromCCWSb3URL
};
